import DealStagesFragments from 'features/deals/DealStages/fragments';

import { gql } from '@apollo/client';

export const ACCEPT_BID = gql`
  mutation AcceptBid($input: AcceptBidInput!) {
    acceptBid(input: $input) {
      id
      ...DealStagesDeal
    }
  }
  ${DealStagesFragments.Deal}
`;
